import { render, staticRenderFns } from "./foodPlan.vue?vue&type=template&id=6334f336&scoped=true"
import script from "./foodPlan.vue?vue&type=script&lang=js"
export * from "./foodPlan.vue?vue&type=script&lang=js"
import style0 from "./foodPlan.vue?vue&type=style&index=0&id=6334f336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6334f336",
  null
  
)

export default component.exports